import React from "react";
import styled, { css } from "styled-components";

export default function Modal({ children, isHidden = true, onClose }) {
  return (
    <StyledModal $isHidden={isHidden}>
      <div className="modal__content">
        <i className="icon icon-close" onClick={onClose} />
        {children}
      </div>
    </StyledModal>
  );
}

const StyledModal = styled.div`
  position: fixed;
  background-color: rgba(11, 11, 11, 0.9);
  height: 100vh;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.4s ease;
  opacity: 1;
  visibility: visible;
  z-index: 5;

  .modal {
    &__content {
      position: relative;

      i {
        width: 28px;
        height: 28px;
        position: absolute;
        top: -36px;
        right: 4px;
        background-color: var(--white);
        opacity: 0.6;

        &:hover {
          opacity: 1;
        }
      }
    }
  }

  ${({ $isHidden }) =>
    $isHidden &&
    css`
      visibility: hidden;
      opacity: 0;
      z-index: 0;
    `}
`;
